import React, { useState } from 'react';
import { useSendActiveScreenEvent, ScreenName } from '@race-planner-web/app-analytics-bridge';
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import { AppPage } from '@race-planner-web/app-page';
import { TimeCalcView } from './time-calc-view';
import { RunIntervalCalcView } from './run-interval-calc-view';
import { WalkIntervalCalcView } from './walk-interval-calc-view';
import { RunPaceCalcView } from './run-pace-calc-view';
import { WalkPaceCalcView } from './walk-pace-calc-view';
import { DistanceCalcView } from './distance-calc-view';
import {
    ContentContainer,
    FlexContainer,
    CalculatorContainer
} from './styled';

const calculatorOptions = [
    {
        key: 'time',
        text: 'Time',
        CalculatorView: TimeCalcView,
        screenEvent: ScreenName.runWalkTimeCalculator
    },
    {
        key: 'distance',
        text: 'Distance',
        CalculatorView: DistanceCalcView,
        screenEvent: ScreenName.runWalkDistanceCalculator
    },
    {
        key: 'running_pace',
        text: 'Running pace',
        CalculatorView: RunPaceCalcView,
        screenEvent: ScreenName.runWalkRunningPaceCalculator
    },
    {
        key: 'walking_pace',
        text: 'Walking pace',
        CalculatorView: WalkPaceCalcView,
        screenEvent: ScreenName.runWalkWalkingPaceCalculator
    },
    {
        key: 'running_interval',
        text: 'Running interval',
        CalculatorView: RunIntervalCalcView,
        screenEvent: ScreenName.runWalkRunningIntervalCalculator
    },
    {
        key: 'walking_interval',
        text: 'Walking interval',
        CalculatorView: WalkIntervalCalcView,
        screenEvent: ScreenName.runWalkWalkingIntervalCalculator
    }
];

export const RunWalkCalculator = () => {
    const [currentCalculator, setCurrentCalculator] = useState(calculatorOptions[0]);

    useSendActiveScreenEvent({ screenName: currentCalculator.screenEvent });

    const onChange = (event, option) => {
        setCurrentCalculator(option);
    };

    const { CalculatorView } = currentCalculator;
    return (
        <AppPage>
            <ContentContainer>
                <h1>Run Walk Calculator</h1>
                <FlexContainer>
                    <Dropdown
                        label='Calculator type'
                        options={calculatorOptions}
                        selectedKey={currentCalculator.key}
                        onChange={onChange}
                    />
                    <CalculatorContainer>
                        <CalculatorView />
                    </CalculatorContainer>
                </FlexContainer>
            </ContentContainer>
        </AppPage>
    );
};
